import {ENDPOINT} from 'config/path'
import CloseIcon from '@mui/icons-material/Close'
import Popup from './components/Popup'
import logoImg from 'assets/images/cpslogo.svg'
import {toggleLoginPopup} from 'features/Login/login.slice'
import {useDispatch} from 'react-redux'
import {type AppDispatch} from 'redux/store'

const LoginPopup = () => {
    const dispatch = useDispatch<AppDispatch>()
    return (
        <div className='blur-background'>
            <div className='login-popup'>
                <div className='login-banner'>
                    <div className='logo-textbox'>
                        <a tabIndex={-1} href={`${process.env.PUBLIC_URL}${ENDPOINT.homepage}`}>
                            <img tabIndex={0} src={logoImg} alt='CPS Logo' className='appLogo headerImg' />
                        </a>
                    </div>
                    <div className='login-banner-content'>
                        <div>
                            <h1 className='popup-heading'>Your results are ready!</h1>
                            <p>Please log in or continue as a guest to view them.</p>
                        </div>
                    </div>
                </div>
                <div className='login-box'>
                    <Popup />
                </div>
                <div className='popup-cancel-btn'>
                    <CloseIcon data-testid='cancel-button' onClick={() => dispatch(toggleLoginPopup(false))} />
                </div>
            </div>
        </div>
    )
}
export default LoginPopup
